import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'rcp-tile-container',
  template: `
    <div
      class="rcp-tile-container"
      [class.column]="direction() === 'vertical'"
      [class.grid-columns]="direction() === 'grid-columns'"
      [class.wrap]="allowWrap()"
    >
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./tile-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TileContainerComponent {
  direction = input<'horizontal' | 'vertical' | 'grid-columns'>('vertical');
  allowWrap = input<boolean>(false);
}
